"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Link = _interopRequireDefault(require("../Link"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const UserMenuOption = ({
  onClick,
  children
}) => {
  return (0, _jsxRuntime.jsx)(_Link.default, {
    trackingName: "Topbar",
    trackingEvent: 'Usermenu click: ' + (children ? children : ''),
    css: theme => [(0, _styles.userMenuOption)(theme)],
    onClick: onClick,
    removeUnderline: true,
    small: true,
    children: children ? children : ''
  });
};
var _default = exports.default = UserMenuOption;